import { Card, Divider, Grid, Paper, Text, Title } from '@mantine/core';
import React from 'react';
import ListInfoBlock from './ListInfoBlock';
import CardSupportingDocument from './CardSupportingDocument';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';

const CardUnblock = ({
  data = {}
}) => {
  const detailUnblockContent = [
    { label: 'Waktu Pengajuan', value: <Text fw={500} fz={18}>{data?.createdAt ? dayjs(data?.createdAt).format('DD MMMM YYYY | HH:mm') : '-'}</Text> },
    // custom bg & color for rejected
    //  | b="#FBE5E6"
    { label: 'Alasan Buka Blokir', value: <Paper bg="#EBF1E1" fw={500} fz={18} p={8} radius={8}>
      {data?.requestReason || '-'}
    </Paper> },
  ];
  if(data?.blockedType === 1){
    detailUnblockContent.splice(1, 0,
      { label: 'Wilayah Transaksi Sebelumnya', value: <Text fw={500} fz={18}>
        {data?.anomalyDetectedIn ? data?.anomalyDetectedIn?.join(', ') : '-'}
      </Text> },
      { label: 'Pengajuan Wilayah Transaksi', value: <Text fw={500} fz={18}>{
        data?.requestedTransactionProvince || '-'
      }</Text> },
    );}

  return (
    <Card h="100%" withBorder>
      <Title order={5}>Rincian Pengajuan Buka Blokir</Title>
      <Grid>
        <Grid.Col span={8}>
          {detailUnblockContent.map((item,idx) => (
            <React.Fragment key={idx}>
              <ListInfoBlock label={item.label} value={item.value} />
              {idx < detailUnblockContent.length - 1 && <Divider my="sm" />}
            </React.Fragment>
          ))}
        </Grid.Col>
        <Grid.Col span={4}>
          <CardSupportingDocument data={data} />
        </Grid.Col>
      </Grid>
    </Card>
  );
};

export default CardUnblock;

CardUnblock.propTypes = {
  data: PropTypes.object
};
